import Helpers from '@Apis/helpers';
import Decimal from 'decimal.js';
import { v4 as uuidv4 } from 'uuid';
import dayjs from 'dayjs';
import Constants, { DEFAULT_CUR_ROUND_OFF, QUANTITY, toISTDate } from '@Apis/constants';
import { notification, Select } from 'antd';
import CustomFieldHelpers from '@Helpers/CustomFieldHelpers';
import FormHelpers from '@Helpers/FormHelpers';

import React from 'react';

import PRZSelect from '../../../Common/UI/PRZSelect';

const { Option } = Select;

const SelectGRNForAPInvoice = ({
  disabled, mode, onChange, selectedGRNValue, grnData, loading, inputClassName, onClear,
}) => (
  <PRZSelect
    getPopupContainer={(triggerNode) => triggerNode.parentNode}
    placeholder="Select GRN.."
    labelInValue
    disabled={disabled}
    filterOption={false}
    showSearch
    allowClear
    value={selectedGRNValue}
    maxTagCount="responsive"
    mode={mode}
    onChange={onChange}
    loading={loading}
    className={inputClassName}
    onClear={onClear}
  >
    {grnData?.grn
      ?.filter((item) => item?.closing_status !== 'CLOSED')
      ?.map((item) => (
        <Option key={item.grn_id} value={item.grn_id}>
          {`#${item.grn_number} (${toISTDate(item.created_date || item.created_at).format(
            'DD/MM/YYYY',
          )}) - `}
        </Option>
      ))}
  </PRZSelect>
);
export default SelectGRNForAPInvoice;
